import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";

const Purchase_Order_View = () => {
   useAuthRedirect();
    const {poNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [poDetail, setPoDetail] = useState({});
  const canView  = hasPermission("Branch Office Purchase Order", "view");
    const [data, setData] = useState([])


  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bopurchaseOrder_detailsHeader?poNo=${poNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                purchaseOrderHeader_podate: items[0].purchaseOrderHeader_podate,
                purchaseOrderHeader_suppliercode: items[0].purchaseOrderHeader_suppliercode,
                purchaseOrderHeader_supplierName: items[0].purchaseOrderHeader_supplierName,
                purchaseOrderHeader_yourReferenceNumber: items[0].purchaseOrderHeader_yourReferenceNumber,
                purchaseOrderHeader_yourReferenceDate: items[0].purchaseOrderHeader_yourReferenceDate,
                purchaseOrderHeader_ourReferenceNumber: items[0].purchaseOrderHeader_ourReferenceNumber,
                purchaseOrderHeader_ourReferenceDate: items[0].purchaseOrderHeader_ourReferenceDate,
                supplierMaster_addressline1: items[0].supplierMaster_addressline1,
                supplierMaster_addressline2: items[0].supplierMaster_addressline2,
                supplierMaster_pincode: items[0].supplierMaster_pincode,
                supplierMaster_city: items[0].supplierMaster_city,
                purchaseOrderHeader_value: items[0].purchaseOrderHeader_value,
                purchaseOrderHeader_CSTtax: items[0].purchaseOrderHeader_CSTtax,
                purchaseOrderHeader_discount: items[0].purchaseOrderHeader_discount,
                purchaseOrderHeader_pfcharges: items[0].purchaseOrderHeader_pfcharges,
                purchaseOrderHeader_freightCharges: items[0].purchaseOrderHeader_freightCharges,
                purchaseOrderHeader_paymentTerms: items[0].purchaseOrderHeader_paymentTerms,
                purchaseOrderHeader_deliveryMethod: items[0].purchaseOrderHeader_deliveryMethod,
                purchaseOrderHeader_remarks: items[0].purchaseOrderHeader_remarks,
                purchaseOrderHeader_totalValue: items[0].purchaseOrderHeader_totalValue,
                
            };

            setPoDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [poNo, branch]); 


  const [loading, setLoading] = useState(true); // ✅ loading state

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/bopurchaseOrder_detailsBottom?branch=${branch}&poNo=${poNo}`
      );

      if (response.data && response.data.headerDetails2) {
        setData(response.data.headerDetails2);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false); // stop loading
    }
  };

  fetchData();
}, [branch, poNo]);
   if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
             <div className="back-div">
                                            <h2 className="add-txt">Misc Purchase Order - View</h2>
                                            <Link to='/inventory/miscPoView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>P.O Number :</label>
                <input type="text" name="PoNumber" value={poNo} readOnly />
              </div>
              <div className="form-group">
                <label>P.O Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.purchaseOrderHeader_podate ? 
         new Date(poDetail.purchaseOrderHeader_podate).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={poDetail.purchaseOrderHeader_suppliercode} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={poDetail.purchaseOrderHeader_supplierName} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Your Ref No :</label>
                <input type="text" name="yourRefNo"   value={poDetail.purchaseOrderHeader_yourReferenceNumber} readOnly/>
              </div>
              <div className="form-group">
                <label>Your Ref Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.purchaseOrderHeader_yourReferenceDate ? 
         new Date(poDetail.purchaseOrderHeader_yourReferenceDate).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Our Ref No :</label>
                <input type="text" name="ourRefNo" value={poDetail.purchaseOrderHeader_ourReferenceNumber} readOnly />
              </div>
              <div className="form-group">
                <label>Our Ref Date :</label>
                <input type="text" name="endhrs"value={poDetail.purchaseOrderHeader_ourReferenceDate ? new Date(poDetail.purchaseOrderHeader_ourReferenceDate).toLocaleDateString("en-GB") : ""}readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={poDetail.supplierMaster_addressline1} readOnly/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={poDetail.supplierMaster_addressline2} readOnly/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={poDetail.supplierMaster_city} readOnly/>
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={poDetail.supplierMaster_pincode} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>PF%</th>
                    <th>Disc%</th>
                    <th>Value</th>
                  </tr>
                </thead>
         <tbody>
  {loading ? (
    <tr>
      <td colSpan="11" style={{ textAlign: "center", fontWeight: "bold" }}>
        Loading data, please wait...
      </td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.purchaseOrderDetail_itemCode}</td>
        <td>{item.itemmaster_name}</td>
        <td>{item.itemmaster_drawingNumber}</td>
        <td>{item.itemMaster_purchaseUom}</td>
        <td>{item.purchaseOrderDetail_orderedQuantity}</td>
        <td>{item.purchaseOrderDetail_price}</td>
        <td>{item.purchaseOrderDetail_CSTtax}</td>
        <td>{item.purchaseOrderDetail_PFpercentage}</td>
        <td>{item.purchaseOrderDetail_discountPercentage}</td>
        <td>
          {new Intl.NumberFormat("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(item.purchaseOrderDetail_value)}
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="11" style={{ textAlign: "center" }}>
        No items
      </td>
    </tr>
  )}
</tbody>




              </table>
            </div>
                
          </form>
           
        </div>
        
         {/* Billing Summary */}
         <div className="po-bill-container">
                    <h2 className="po-bill-title">Billing Summary</h2>
                    <div className="po-bill-summary">
                    <div className="po-bill-item">
                        <span className="po-bill-label">Sub Total:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.purchaseOrderHeader_value)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">GST (%):</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.purchaseOrderHeader_CSTtax)}</span>

                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Disc (%):</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.purchaseOrderHeader_discount)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">PF:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.purchaseOrderHeader_pfcharges)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Fright Charges:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.purchaseOrderHeader_freightCharges)}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Payment Terms:</span>
                        <span className="po-bill-value">{poDetail.purchaseOrderHeader_paymentTerms}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Delivery Method:</span>
                        <span className="po-bill-value">{poDetail.purchaseOrderHeader_deliveryMethod}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Remarks:</span>
                        <span className="po-bill-value">{poDetail.purchaseOrderHeader_remarks}</span>
                    </div>
                    <div className="po-bill-item po-bill-total">
                        <span className="po-bill-label">Total:</span>
                        <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(poDetail.purchaseOrderHeader_totalValue)}</span>
                    </div>

                    </div>
              </div>
      </div>
      
    </div>
  );
};

export default Purchase_Order_View;
